import React from 'react';
import ReactDOM from 'react-dom';

import { debounce } from 'debounce';
import TrackHoverCard from '../../../../components/cards/TrackHoverCard';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { DateFormatting } from '../../../../utils/date-formatting';
import { monthDayYear } from '../../../../utils/time_helpers';

const createReactClass = require('create-react-class');

const UserStatsDashboard = createReactClass({
  getInitialState() {
    const { languageRegionCode } = this.props.context;
    this.thisYear = new Date().getFullYear();
    this.month_names_short = DateFormatting.locale[languageRegionCode].month_names_short;

    let max_year = null;
    for (const year in this.props.stats.by_year) if (max_year === null || year > max_year) max_year = year;
    if (max_year === null) max_year = this.thisYear;
    return {
      year: max_year,
      item: 'distance'
    };
  },
  componentDidMount() {
    this.googleChart = null;
    this.createChart(this.refs.statsChart);

    window.addEventListener(
      'resize',
      debounce(() => this.createChart(this.refs.statsChart)),
      200
    );
  },
  componentDidUpdate(prevProps, prevState) {
    if (this.state.year != prevState.year || this.state.item != prevState.item) this.createChart(this.refs.statsChart);
  },
  createChart(dom_element) {
    if (!google.visualization) {
      google.charts.load('current', { packages: ['corechart', 'bar'], language: this.props.context.languageRegionCode });
      google.charts.setOnLoadCallback(
        function() {
          this.createChart(dom_element);
        }.bind(this)
      );
      return;
    }

    if (this.data) {
      while (this.data.getNumberOfRows() > 0) this.data.removeRow(this.data.getNumberOfRows() - 1);
      while (this.data.getNumberOfColumns() > 0) this.data.removeColumn(this.data.getNumberOfColumns() - 1);
    } else {
      this.data = new google.visualization.DataTable();
    }

    const for_year = this.props.stats.by_year[this.state.year];
    let max = 0;
    let yearTotal = 0.0;
    let vAxisTicks = 4;
    this.data.addColumn('string', 'Month');
    if (for_year) {
      for (var month = 1; month <= 12; month++) {
        if (for_year[month] && for_year[month].maps.length > max) max = for_year[month].maps.length;
      }
      for (var i = 0; i < max; i++) {
        this.data.addColumn('number', i + 1);
        this.data.addColumn({ type: 'string', role: 'style' });
      }
      // we need to convert the units for the individual row for the graph and then for the year
      let convertedValue;
      let value;
      for (var month = 1; month <= 12; month++) {
        const row = [this.month_names_short[month - 1].substr(0, 1)];
        for (var i = 0; i < max; i++) {
          if (for_year[month] && for_year[month].maps[i]) {
            const track = for_year[month].maps[i];
            switch (this.state.item) {
              case 'distance':
                convertedValue = MapStatsUtil.totalDistance({ distanceTotal: track.distance }, this.props.context.displayMetric);
                value = track.distance;
                break;
              case 'elevation_gain':
                convertedValue = MapStatsUtil.elevationGain({ elevationGain: track.elevation_gain }, this.props.context.displayMetric);
                value = track.elevation_gain;
                break;
              case 'time_moving':
                convertedValue = MapStatsUtil.secondsToHours(track.time_moving);
                value = track.time_moving;
                break;
              case 'calories':
                convertedValue = track.calories;
                value = track.calories;
                break;
              case 'count':
                convertedValue = 1;
                value = 1;
                break;
            }
            yearTotal += value;
            row.push(convertedValue);
            row.push('stroke-color: white; stroke-opacity: 1.0; stroke-width: 1');
          } else {
            row.push(null);
            row.push(null);
          }
        }
        this.data.addRow(row);
      }
    }

    let titleText;
    let vAxisLabel = null;
    let vAxisFormat = null;
    let verb = StringConstantsMixin.strings.STATS.NORMAL.RECORDED_IN;
    switch (this.state.item) {
      case 'distance':
        verb = `${StringConstantsMixin.strings.STATS.NORMAL.TOTAL_DISTANCE} ${verb}`;
        titleText = MapStatsUtil.metersToFormattedUserUnits(yearTotal, 0, this.props.context.displayMetric, this.props.context.languageRegionCode);
        vAxisLabel = this.props.context.displayMetric ? 'km' : 'mi';
        break;
      case 'elevation_gain':
        verb = `${StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN} ${verb}`;
        titleText = MapStatsUtil.elevationFormatted(yearTotal, this.props.context.displayMetric, this.props.context.languageRegionCode);
        vAxisLabel = this.props.context.displayMetric ? 'meters' : 'feet';
        break;
      case 'time_moving':
        verb = `${StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME} ${verb}`;
        titleText = MapStatsUtil.secondsToTimeNo24HourLimit(yearTotal);
        vAxisLabel = 'hours';
        break;
      case 'calories':
        verb = `${StringConstantsMixin.strings.STATS.NORMAL.CALORIES} ${verb}`;
        titleText = MapStatsUtil.caloriesFormatted(yearTotal, this.props.context.languageRegionCode);
        vAxisLabel = 'calories';
        break;
      case 'count':
        verb = `${StringConstantsMixin.strings.TAB_NAMES.RECORDINGS} in`;
        titleText = <span>{yearTotal || '0'}</span>;
        vAxisLabel = 'recordings';
        vAxisFormat = '0';
        if (max < 3) vAxisTicks = max + 1;
        break;
    }
    titleText = (
      <span>
        {titleText} {verb} {this.state.year}
      </span>
    );
    ReactDOM.render(titleText, document.getElementById('chart-title'));

    // Empty chart?
    if (this.data.getNumberOfRows() == 0) {
      this.data.addColumn('number', 1);
      for (let month = 1; month <= 12; month++) {
        const row = [this.month_names_short[month - 1].substr(0, 1), 0];
        this.data.addRow(row);
      }
      vAxisTicks = 0;
    }

    const options = {
      chartArea: { left: 70, top: 10, right: 30, bottom: 30 },
      legend: 'none',
      bar: { groupWidth: '97%' },
      colors: ['#428A13'],
      backgroundColor: 'none',
      isStacked: true,
      tooltip: {
        isHtml: true,
        ignoreBounds: true
      },
      hAxis: {
        textStyle: {
          color: '#666'
        }
      },
      vAxis: {
        title: vAxisLabel,
        format: vAxisFormat,
        titleTextStyle: {
          color: '#666'
        },
        gridlines: {
          count: vAxisTicks
        }
      },
      animation: { startup: true, duration: 300 }
    };

    if (!this.googleChart) {
      const { mobileBrowser } = this.props.context;
      this.googleChart = new google.visualization.ColumnChart(dom_element);
      google.visualization.events.addListener(this.googleChart, 'select', a => {
        const selectedItem = this.googleChart.getSelection()[0];
        if (mobileBrowser) {
          this.openToolTip(selectedItem);
        } else if (selectedItem) {
          const for_year = this.props.stats.by_year[this.state.year];
          const track = for_year[selectedItem.row + 1] ? for_year[selectedItem.row + 1].maps[(selectedItem.column - 1) / 2] : null;
          if (track && track.slug) window.open(`/explore/recording/${track.slug}`, '_blank');
          this.googleChart.setSelection([{}]);
          const tooltip = $('.google-visualization-tooltip');
          tooltip.css('display', 'none');
        }
      });
      if (!mobileBrowser) {
        google.visualization.events.addListener(this.googleChart, 'onmouseover', selectedItem => {
          this.openToolTip(selectedItem);
        });
        google.visualization.events.addListener(this.googleChart, 'onmouseout', selectedItem => {
          this.selectedItem = null;
        });
      }
    }
    document.querySelector('.chart-panel').addEventListener('click', e => {
      this.hideHoverCard();
    });
    this.googleChart.draw(this.data, options);
  },
  openToolTip(selectedItem) {
    const tooltip = $('.google-visualization-tooltip');
    tooltip.css('display', 'none');
    if (selectedItem && (!this.selectedItem || selectedItem.row != this.selectedItem.row || selectedItem.column != this.selectedItem.column)) {
      this.hideHoverCard();
      this.selectedItem = selectedItem;
      $('#chart_div').css('cursor', 'pointer');
      const forYear = this.props.stats.by_year[this.state.year];
      const track = forYear[selectedItem.row + 1] ? forYear[selectedItem.row + 1].maps[(selectedItem.column - 1) / 2] : null;
      if (track) {
        track.ID = track.id;
        track.type = 'track';
        if (track.name === null) track.name = '';

        // Need to guide our hovercard popup location from that of the built-in tooltip, because this mouse
        // event does not include x,y info.
        const { top, left, popupTipStyles, cardWidth } = this.getToolTipPositioning(tooltip, selectedItem);
        const popup = $('<div class="chart-hover-card"><div class="card"></div><div class="popup-tip"></div></div>').appendTo($('#chart_div'));
        popup.css({ top: `${top}px`, left: `${left}px` });
        $('.chart-hover-card .popup-tip').css(popupTipStyles);

        const cardDiv = $('.chart-hover-card .card')[0];
        ReactDOM.render(
          React.createFactory(TrackHoverCard)({
            track,
            context: this.props.context,
            handleCardClick() {
              if (track.slug) {
                window.open(window.checkLinkAndAppendLanguage(`/explore/recording/${track.slug}`), '_blank');
              }
            },
            handleMouseLeave: () => {
              this.hideHoverCard();
            },
            containerWidth: cardWidth
          }),
          cardDiv
        );
      }
    }
  },
  // makes the tooltip popup fit inside the graph
  adjustWidthForMobileDevices() {
    const lowerEndWidth = 365;
    const panelWidth = $('.chart-panel').width();

    return panelWidth <= lowerEndWidth ? panelWidth - 25 : 344;
  },
  getToolTipPositioning(tooltip, selectedItem) {
    let top;
    let left;
    let popupTipStyles;
    const { innerWidth } = window;
    let cardWidth = 344;
    if (innerWidth >= 767) {
      top = parseInt(tooltip.css('top')) + 340;
      left = parseInt(tooltip.css('left')) - (selectedItem.row < 2 ? 46 : 160) - 15;
      popupTipStyles = {
        'margin-left': `${selectedItem.row < 2 ? 31 : 145}px`
      };
    } else {
      top = 340;
      cardWidth = this.adjustWidthForMobileDevices();
      left = (innerWidth - cardWidth) / 2;
      popupTipStyles = {
        display: 'none'
      };
    }

    return { top, left, popupTipStyles, cardWidth };
  },
  hideHoverCard() {
    $('.chart-hover-card').remove();
    $('#chart_div').css('cursor', 'default');
  },
  findTrack(map_id) {
    for (const year in this.props.stats.by_year) {
      for (let month = 1; month <= 12; month++) {
        let track = null;
        if (this.props.stats.by_year[year][month]) {
          this.props.stats.by_year[year][month].maps.forEach(function(map) {
            if (map.id == map_id) {
              track = map;
            }
          });
        }
        if (track) {
          return track;
        }
      }
    }
    return null;
  },
  switchToShow(year, item) {
    this.hideHoverCard();
    this.setState({
      year,
      item
    });
  },
  openRecording(map_id) {
    const track = this.findTrack(map_id);
    if (track) window.open(window.checkLinkAndAppendLanguage(`/explore/recording/${track.slug}`), '_blank');
  },
  formatStats() {
    const { displayMetric, languageRegionCode } = this.props.context;

    const distance = MapStatsUtil.metersToFormattedUserUnits(this.props.stats.totals.distance, 0, displayMetric, languageRegionCode);
    const bestDistance = MapStatsUtil.metersToFormattedUserUnits(this.props.stats.bests.distance.value, 1, displayMetric, languageRegionCode);
    const elevationGain = MapStatsUtil.elevationFormatted(this.props.stats.totals.elevation_gain, displayMetric, languageRegionCode);
    const bestElevationGain = MapStatsUtil.elevationFormatted(this.props.stats.bests.elevation_gain.value, displayMetric, languageRegionCode);
    const calories = MapStatsUtil.caloriesFormatted(this.props.stats.totals.calories, languageRegionCode);
    const recordingsCount = MapStatsUtil.formatData(this.props.stats.totals.recordings_count, 0, '', languageRegionCode);
    const timeMoving = MapStatsUtil.secondsToTimeNo24HourLimit(this.props.stats.totals.time_moving);
    const bestTimeMoving = MapStatsUtil.secondsToTimeNo24HourLimit(this.props.stats.bests.time_moving.value);
    const bestCalories = MapStatsUtil.caloriesFormatted(this.props.stats.bests.calories.value, languageRegionCode);
    const bestMonthlyCount = MapStatsUtil.formatData(this.props.stats.bests.recordings_per_month.value, 0, '', languageRegionCode);

    return {
      distance,
      elevationGain,
      bestDistance,
      bestElevationGain,
      calories,
      recordingsCount,
      timeMoving,
      bestTimeMoving,
      bestCalories,
      bestMonthlyCount
    };
  },
  render() {
    const {
      distance,
      elevationGain,
      bestDistance,
      bestElevationGain,
      calories,
      recordingsCount,
      timeMoving,
      bestTimeMoving,
      bestCalories,
      bestMonthlyCount
    } = this.formatStats();

    let bestDistanceLabel = null;
    let bestElevationGainLabel = null;
    let bestTimeMovingLabel = null;
    let bestCaloriesLabel = null;
    let bestMonthlyCountLabel = null;
    let bestDistanceId = null;
    let bestElevationGainId = null;
    let bestTimeMovingId = null;
    let bestCaloriesId = null;
    let bestMonthlyCountYear = null;

    if (bestMonthlyCount > 0) {
      bestDistanceLabel = monthDayYear(this.props.stats.bests.distance.date, this.props.context.languageRegionCode, false);
      bestElevationGainLabel = monthDayYear(this.props.stats.bests.elevation_gain.date, this.props.context.languageRegionCode, false);
      bestTimeMovingLabel = monthDayYear(this.props.stats.bests.time_moving.date, this.props.context.languageRegionCode, false);
      bestCaloriesLabel = monthDayYear(this.props.stats.bests.calories.date, this.props.context.languageRegionCode, false);
      bestMonthlyCountLabel = `${this.month_names_short[this.props.stats.bests.recordings_per_month.month - 1]} ${
        this.props.stats.bests.recordings_per_month.year
      }`;

      bestDistanceId = this.props.stats.bests.distance.at_map_id;
      bestElevationGainId = this.props.stats.bests.elevation_gain.at_map_id;
      bestTimeMovingId = this.props.stats.bests.time_moving.at_map_id;
      bestCaloriesId = this.props.stats.bests.calories.at_map_id;
      bestMonthlyCountYear = this.props.stats.bests.recordings_per_month.year;
    }

    let nextYear = null;
    let prevYear = null;
    if (this.state.year < this.thisYear)
      nextYear = (
        <div className="year-link link" onClick={this.switchToShow.bind(null, parseInt(this.state.year) + 1, this.state.item)}>
          {parseInt(this.state.year) + 1} &gt;
        </div>
      );
    else nextYear = <div className="year-link link" />;
    if (this.state.year > 1972)
      prevYear = (
        <div className="year-link link" onClick={this.switchToShow.bind(null, parseInt(this.state.year) - 1, this.state.item)}>
          &lt; {parseInt(this.state.year) - 1}
        </div>
      );
    else prevYear = <div className="year-link link" />;

    return (
      <div className="stats-panel xlate-none">
        <div className="lifetime">
          <h4 className={StringConstantsMixin.constants.XLATE.NONE}>{StringConstantsMixin.strings.STATS.NORMAL.LIFETIME_STATS}</h4>
          <div className="stats-section">
            <span className="stat">
              <div
                className={`icon total-distance${this.state.item == 'distance' ? ' selected' : ''}`}
                onClick={this.switchToShow.bind(null, this.state.year, 'distance')}
              />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{distance}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.TOTAL_DISTANCE}
              </div>
            </span>
            <span className="stat">
              <div
                className={`icon elevation-gain${this.state.item == 'elevation_gain' ? ' selected' : ''}`}
                onClick={this.switchToShow.bind(null, this.state.year, 'elevation_gain')}
              />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{elevationGain}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN}
              </div>
            </span>
            <span className="stat">
              <div
                className={`icon moving-time${this.state.item == 'time_moving' ? ' selected' : ''}`}
                onClick={this.switchToShow.bind(null, this.state.year, 'time_moving')}
              />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{timeMoving}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME}
              </div>
            </span>
            <span className="stat">
              <div
                className={`icon calories${this.state.item == 'calories' ? ' selected' : ''}`}
                onClick={this.switchToShow.bind(null, this.state.year, 'calories')}
              />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{calories}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.CALORIES_BURNED}
              </div>
            </span>
            <span className="stat">
              <div
                className={`icon recordings-count${this.state.item == 'count' ? ' selected' : ''}`}
                onClick={this.switchToShow.bind(null, this.state.year, 'count')}
              />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{recordingsCount}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}># {StringConstantsMixin.strings.TAB_NAMES.RECORDINGS}</div>
            </span>
          </div>
        </div>

        <h4 className={StringConstantsMixin.constants.XLATE.NONE}>{StringConstantsMixin.strings.STATS.NORMAL.ANNUAL_STATS}</h4>
        <div className="chart-panel">
          <div className="chart-title">
            {prevYear}
            <h4 id="chart-title" />
            {nextYear}
          </div>
          <div id="chart_div" ref="statsChart" />
          <div className="chart-controls">
            <nav className="carousel center-block">
              <input id="carousel-item-1" type="radio" checked={this.state.item == 'distance'} />
              <label
                htmlFor="carousel-item-1"
                className={StringConstantsMixin.constants.XLATE.NONE}
                onClick={this.switchToShow.bind(null, this.state.year, 'distance')}
                title={StringConstantsMixin.strings.STATS.NORMAL.DISTANCE}
              />
              <input id="carousel-item-2" type="radio" checked={this.state.item == 'elevation_gain'} />
              <label
                htmlFor="carousel-item-2"
                className={StringConstantsMixin.constants.XLATE.NONE}
                onClick={this.switchToShow.bind(null, this.state.year, 'elevation_gain')}
                title={StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN}
              />
              <input id="carousel-item-3" type="radio" checked={this.state.item == 'time_moving'} />
              <label
                htmlFor="carousel-item-3"
                className={StringConstantsMixin.constants.XLATE.NONE}
                onClick={this.switchToShow.bind(null, this.state.year, 'time_moving')}
                title={StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME}
              />
              <input id="carousel-item-4" type="radio" checked={this.state.item == 'calories'} />
              <label
                htmlFor="carousel-item-4"
                className={StringConstantsMixin.constants.XLATE.NONE}
                onClick={this.switchToShow.bind(null, this.state.year, 'calories')}
                title={StringConstantsMixin.strings.STATS.NORMAL.CALORIES}
              />
              <input id="carousel-item-5" type="radio" checked={this.state.item == 'count'} />
              <label
                htmlFor="carousel-item-5"
                className={StringConstantsMixin.constants.XLATE.NONE}
                onClick={this.switchToShow.bind(null, this.state.year, 'count')}
                title={StringConstantsMixin.strings.STATS.NORMAL.COUNT}
              />
            </nav>
          </div>
        </div>

        <div className="personal-best">
          <h4 className={StringConstantsMixin.constants.XLATE.NONE}>{StringConstantsMixin.strings.STATS.NORMAL.PERSONAL_BESTS}</h4>
          <div className="stats-section">
            <span className="stat">
              <div className="icon total-distance" onClick={this.openRecording.bind(null, bestDistanceId)} />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestDistance}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.LONGEST_DISTANCE}
              </div>
              <div className={`date-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestDistanceLabel}</div>
            </span>
            <span className="stat">
              <div className="icon elevation-gain" onClick={this.openRecording.bind(null, bestElevationGainId)} />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestElevationGain}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN}
              </div>
              <div className={`date-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestElevationGainLabel}</div>
            </span>
            <span className="stat">
              <div className="icon moving-time" onClick={this.openRecording.bind(null, bestTimeMovingId)} />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestTimeMoving}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME}
              </div>
              <div className={`date-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestTimeMovingLabel}</div>
            </span>
            <span className="stat">
              <div className="icon calories" onClick={this.openRecording.bind(null, bestCaloriesId)} />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestCalories}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{StringConstantsMixin.strings.STATS.NORMAL.CALORIES}</div>
              <div className={`date-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestCaloriesLabel}</div>
            </span>
            <span className="stat">
              <div className="icon recordings-count" onClick={this.switchToShow.bind(null, bestMonthlyCountYear, 'count')} />
              <div className={`data ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestMonthlyCount}</div>
              <div className={`stats-label ${StringConstantsMixin.constants.XLATE.NONE}`}>
                {StringConstantsMixin.strings.TAB_NAMES.RECORDINGS}
                {StringConstantsMixin.strings.STATS.ABBR.PER_MONTH}
              </div>
              <div className={`date-label ${StringConstantsMixin.constants.XLATE.NONE}`}>{bestMonthlyCountLabel}</div>
            </span>
          </div>
        </div>
      </div>
    );
  }
});

export { UserStatsDashboard };
